import * as React from "react";
import { useParams } from "react-router";

export default () => {
  return <div>Ladda upp eventuella bilagor som ska med på avtalet.</div>;
};
